import { SCORECARD_TAGS } from "../common.js";
import { xCardScorecardApi } from "../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardIncidentsHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getIncidents: builder.query({
      query: ({ payload, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/incidents` : `/incidents`,
          body: payload,
          method: "POST"
        };
      },
      providesTags: (result, error, { cacheKey }) => [{ type: SCORECARD_TAGS.XCARD_INCIDENTS, cacheKey }]
    })
  })
});
const { usePrefetch: useIncidentsApiPrefetch, useGetIncidentsQuery } = xCardIncidentsHooks;
export {
  useGetIncidentsQuery,
  useIncidentsApiPrefetch,
  xCardIncidentsHooks
};
//# sourceMappingURL=incidents.js.map
